import { Tapume } from '../../types/tapume.types';

export const tapume: Tapume = {
  titulo: 'Desculpe, estamos enfrentando alguns desafios técnicos no momento',
  conteudo: [
    'Nossa equipe está empenhada em resolver o problema o mais rápido possível.',
    'Por favor, tente novamente mais tarde.',
  ],
};
